import { LIST_DROPDOWN_VALUES } from 'ui-components/dist/ListDropdown';

export const SAVED_LIST_PAGESIZE = 24;
export const SAVED_LIST_COLLAPSED_PAGESIZE = 8;

export const SAVED_LIST_DEFAULT_CONTEXT = LIST_DROPDOWN_VALUES.AGENCY_LISTS;
